import React from 'react'
import ReactDOM from 'react-dom'
import {adminInit, initApi, getVersion} from 'utils/api'
import 'index.css'
import App from 'App'
import reportWebVitals from 'reportWebVitals'

adminInit()
console.log(`flClient initialized v${initApi()}`)
console.log(`flBusiness initialized v${getVersion()}`)


ReactDOM.render(
    <App />,
document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
